<template>
  <div class="dialog-wrap">
    <el-dialog title="订单详情"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :width="dialogWidth">
      <div class="order-wrap">
        <div class="card-wrap">
          <div class="inner">
            <div class="title">基础信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">订单状态：</div>
                <div class="value">{{ statusRender() }}</div>
                <!-- <div class="value">
                  <el-select v-model="content.status"
                             placeholder="请选择"
                             @change="changeStatus">
                    <el-option label="待支付"
                               :value="0"> </el-option>
                    <el-option label="已支付"
                               :value="1"> </el-option>
                    <el-option label="待发货"
                               :value="2"> </el-option>
                    <el-option label="待收货"
                               :value="3"> </el-option>
                    <el-option label="已完成"
                               :value="4"> </el-option>
                    <el-option label="已取消"
                               :value="5"> </el-option>
                  </el-select>
                </div> -->
              </div>
              <div class="info-row">
                <div class="label">创建时间：</div>
                <div class="value">
                  {{
                    $moment(content.create_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    ) || "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">系统订单号：</div>
                <div class="value">{{ content.order_no || "--" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap"
             v-if="activityInfo">
          <div class="inner"
               v-if="activityInfo.activity_group">
            <div class="title">拼团信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">拼团ID：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.id }}
                </div>
                <div v-else> -</div>
              </div>
              <div class="info-row">
                <div class="label">拼团状态：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    formateActivityStatus(activityInfo.activity_group.status)
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">拼团人数：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.user_count }}人团
                </div>
              </div>
              <div class="info-row">
                <div class="label">已拼人数：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.done_user_count }}人
                </div>
              </div>
              <div class="info-row">
                <div class="label">发起时间：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    $moment(activityInfo.activity_group.create_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    )
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">更新时间：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    $moment(activityInfo.activity_group.update_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">商品信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">商品封面：</div>
                <div class="value">
                  <div v-if="content.product_type == 7">
                    <img v-for="(item, index) in content.multi_ref_list"
                         :key="index"
                         :src="item.goods_img"
                         alt=""
                         style="margin: 0px 6px" />
                  </div>
                  <img :src="content.goods_img"
                       alt="" />
                </div>
              </div>
              <div class="info-row">
                <div class="label">商品类型：</div>
                <div class="value">
                  {{
                    {
                      "0": "无",
                      "1": "课程",
                      "2": "题库",
                      "3": "专栏",
                      "4": "资料",
                      "5": "文章",
                      "6": "学长",
                      "7": "联报",
                    }[content.product_type] || "--"
                  }}
                </div>
              </div>
              <div class="info-row"
                   style="align-items: start">
                <div class="label">商品名称：</div>
                <div class="goods-name-value"
                     v-if="content.product_type == 7">
                  <span class="goods-name-span"
                        v-for="(item, index) in content.multi_ref_list"
                        :key="index">{{ item.goods_name }}</span>
                </div>
                <span v-else>{{ content.goods_name }}</span>
              </div>
              <div class="info-row"
                   v-if="properties.length > 0">
                <div class="label">商品规格：</div>
                <div v-for="(item,i) in properties"
                     :key="i">
                  <span class="properties-style"> {{item.key}}：{{item.val}}
                    <template v-if="i < properties.length - 1">,</template>
                    <template v-else>;</template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">支付信息</div>
            <div class="info-wrap">
              <!--  联报，多个商品原价  start-->
              <div class="info-row"
                   v-if="content.product_type == 7">
                <div class="label">商品价格：</div>
                <div class="value">{{ formateMulti_ref_listPrice() }}</div>
              </div>
              <!--  联报，多个商品原价  end-->

              <!--  联报，多个商品联报价  start-->
              <div class="info-row"
                   v-if="content.product_type == 7">
                <div class="label">联报优惠：</div>
                <div class="value">{{ formateMulti_ref_listJointPrice() }}</div>
              </div>
              <!--  联报，多个商品联报价   end-->

              <div class="info-row"
                   v-else>
                <div class="label">商品价格：</div>
                <div class="value">{{ content.product_price || "0" }}元</div>
              </div>
              <div class="info-row">
                <div class="label">采购份数：</div>
                <div class="value">
                  {{ content.order_count || "0" }}份
                </div>
              </div>
              <div class="info-row">
                <div class="label">订单总金额：</div>
                <div class="value">{{ content.order_amount || "0" }}元</div>
              </div>
              <div class="info-row">
                <div class="label">支付金额：</div>
                <div class="value">{{ content.payment_pay_amount || "0" }}元</div>
              </div>

              <div class="info-row">
                <div class="label">支付方式：</div>
                <div class="value">
                  {{
                    {
                      "0": "--",
                      "1": "支付宝",
                      "2": "微信",
                      "3": "余额",
                     
                    }[content.payment_pay_type] || "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">支付状态：</div>
                <div class="value">
                  {{
                    { "0": "未支付", "1": "已支付", }[
                      content.payment_pay_status
                    ] || "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">支付时间：</div>
                <div class="value">
                  {{
                    content.payment_pay_time
                      ? $moment(content.payment_pay_time).format("YYYY.MM.DD HH:mm:ss")
                      : "--"
                  }}
                </div>
              </div>

              <div class="info-row">
                <div class="label">支付订单号：</div>
                <div class="value">{{ content.payment_out_trade_no || "--" }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-wrap">
          <div class="inner">
            <div class="title">加盟商信息</div>
            <div class="info-wrap">

              <div class="info-row">
                <div class="label">机构：</div>
                <div class="value">{{ user.warrant_user_company_name || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">姓名：</div>
                <div class="value">{{ user.warrant_user_alias || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">手机号：</div>
                <div class="value">{{ user.warrant_user_phone
 || "--" }}</div>
              </div>

            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">收件信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">收件人姓名：</div>
                <div class="value">{{ content.receiver_name || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">收件人手机号：</div>
                <div class="value">{{ content.receiver_mobile || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">收件人邮箱：</div>
                <div class="value">{{ content.receiver_email || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">收件人地址：</div>
                <div class="value">{{ content.receiver_address || "--" }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>


<script>
import { warrantOrderOne } from '@/api/warrant.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    userContent: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      // 商品规格
      properties: [],
      dialogVisible: this.visible,
      user: this.userContent || {},
      isRefund: false,
      activityInfo: null,
      dialogWidth: document.body.clientWidth < 820 ? '400px' : '680px',
      content: {},
      unsplit_amount: 0,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchOrderdetail()
        /*     if (this.content.activity_id) {
              this.fetActivityInfo()
            } */
      }
    },
    userContent(val) {
      this.user = val
    },
  },

  methods: {
    fetchOrderdetail() {
      const query = {
        id: this.id,
      }
      warrantOrderOne(query).then((res) => {
        if (res) {
          this.content = res
          if (res.sku) {
            this.properties = res.sku.properties
            console.log('this.properties', this.properties)
          }
        }
      })
    },

    handleClose() {
      this.properties = []
      this.activityInfo = null
      this.$emit('close')
    },
    // 订单状态渲染
    statusRender() {
      const pay_status = {
        0: '未支付',
        1: '已支付',
        2: '已取消',
      }
      const audit_status = {
        0: '待审核',
        1: '审核通过',
        2: '审核未通过',
      }
      const refund_status = {
        0: '未申请',
        1: '退款中',
        2: '已退款',
      }
      return pay_status[this.content.status] || '--'
    },
    changeStatus(e) {
      let query = {
        id: this.content.id,
        status: this.content.status,
      }
      memberOrderUpdate(query).then((res) => {})
    },

    formatJointProduct(row) {
      if (row.multi_ref_list.length) {
        let str = row.multi_ref_list
          .map((v) => {
            return v.goods_name
          })
          .join(',')
        return str
      } else {
        return '无'
      }
    },

    formateActivityStatus(status) {
      const obj = ['正在拼团', '拼团成功', '拼团失败']
      return obj[status]
    },
    formateMulti_ref_listPrice() {
      let arr = this.content.multi_ref_list.map((v) => {
        if (v.price) {
          return v.price.toFixed(2) + '元'
        } else {
          return '未知'
        }
      })
      return arr.join('/')
    },
    formateMulti_ref_listJointPrice() {
      let arr = this.content.multi_ref_list.map((v) => {
        if (v.price) {
          return (v.price - v.joint_price).toFixed(2) + '元'
        } else {
          return '未知'
        }
      })
      return arr.join('/')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .order-wrap {
    display: flex;
    flex-direction: column;
    .wrap-item {
      margin: 20px 40px 0 40px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .card-wrap {
    width: 100%;
    padding: 5px;

    .inner {
      min-height: 100px;
      border: 1px dashed #ccc;
      border-radius: 6px;
      padding: 5px 5px 10px;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
    }
    .info-wrap {
      margin-top: 15px;
    }
    .info-row {
      display: flex;
      align-items: center;
      font-size: 13px;

      & + .info-row {
        margin-top: 10px;
      }

      .label {
        width: 120px;
        text-align: right;
        color: #666;
      }
      .goods-name-value {
        margin-left: 10px;
        .goods-name-span {
          display: block;
          margin-bottom: 5px;
        }
      }
      .value {
        flex: 1;
        color: #333;
        margin-left: 10px;
      }
      .properties-style {
        display: inline-block;
        width: 80px;
      }
      img {
        max-width: 80px;
      }
    }
  }

  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  .result {
    margin-top: 10px;
  }
  .footer {
    margin-top: 10px;
  }
}
</style>
